var _rect, _g, _g2, _path, _path2, _g3, _mask, _g4, _circle, _path3, _path4, _path5, _path6, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreetingStyleInteractiveWithButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 59,
    viewBox: "0 0 87 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.691,
    y: 46.465,
    width: 8.012,
    height: 7.535,
    rx: 3.767,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#greeting-style--interactive-with-button_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 43,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#009EFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#greeting-style--interactive-with-button_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.123 5.511a2 2 0 012-2h71.405a2 2 0 012 2v33.172a2 2 0 01-2 2H10.123a2 2 0 01-2-2V5.511z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ADA9BB",
    d: "M75.031 23h-12.37v1.758h12.37zM60.185 23H14v1.758h46.186z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24 3a3 3 0 013-3h70.405a2 2 0 012 2v9.805H8.24V3z",
    fill: "#009EFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#greeting-style--interactive-with-button_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.242,
    cy: 6.028,
    rx: 4.242,
    ry: 4.521,
    fill: "#fff"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "greeting-style--interactive-with-button_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.243,
    cy: 6.026,
    rx: 3.77,
    ry: 4.019,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#greeting-style--interactive-with-button_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.243,
    cy: 6.36,
    rx: 4.608,
    ry: 4.8,
    fill: "#E7E7E9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 49,
    r: 3,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.895 4.397h17.32v3.516h-17.32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADA9BB",
    d: "M13.895 16.703h8.247v1.758h-8.247zM23.793 16.703h11.546v1.758H23.793z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE6FF",
    d: "M32.867 4.397h34.639v3.516H32.867z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADA9BB",
    d: "M36.992 16.703h42.062v1.758H36.992z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 65,
    height: 6,
    rx: 3,
    fill: "#009EFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "greeting-style--interactive-with-button_svg__filter0_d",
    x: 69,
    y: 41,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.122049 0 0 0 0 0.233071 0 0 0 0 0.770833 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "greeting-style--interactive-with-button_svg__filter1_d",
    x: 5.123,
    y: 2.511,
    width: 81.405,
    height: 43.172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "greeting-style--interactive-with-button_svg__filter2_d",
    x: 0,
    y: 0.507,
    width: 16.483,
    height: 17.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default __webpack_public_path__ + "./fonts/greeting-style--interactive-with-button.50270a87f063f925d361cc745ae8bc66.svg";
export { SvgGreetingStyleInteractiveWithButton as ReactComponent };